import React from 'react';
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectStaff, selectPermissions } from "../slices/staffSlice";

function PermissionRoute({ permission }) {
    const staff = useSelector(selectStaff);
    const permissions = useSelector(selectPermissions);

    if (!staff) return <Navigate to="/login" />;

    if (permission && !permissions.includes('*:*') && !permissions.includes(permission)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}

export default PermissionRoute;
